import React, { useCallback, useMemo } from 'react'

import { bool, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

const PLAN_MONTHLY = 'monthly'
const PLAN_YEARLY = 'yearly'

function resolveFeeKey({ planType, gracePeriodEligible }) {
  if (planType === PLAN_MONTHLY) return null
  if (planType === PLAN_YEARLY && !gracePeriodEligible) {
    return 'subscription_management.active.cancel_info.cancellation_fee_new_yearly'
  }
  return 'subscription_management.active.cancel_info.cancellation_fee'
}

function CancelInfo({
  locale = 'en',
  planType = PLAN_YEARLY,
  gracePeriodEligible = true,
}) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale]
  )

  const items = useMemo(() => {
    const feeKey = resolveFeeKey({ planType, gracePeriodEligible })

    return [
      translate('subscription_management.active.cancel_info.keep_access'),
      translate('subscription_management.active.cancel_info.no_downloads'),
      translate('subscription_management.active.cancel_info.keep_license'),
      feeKey ? translate(feeKey) : null,
    ].filter(Boolean)
  }, [translate, planType, gracePeriodEligible])

  return (
    <div className="cancel-info">
      <h3 className="cgt-legacy-heading-h4">
        {translate('subscription_management.active.cancel_info.title')}
      </h3>
      <ul className="cancel-info__list">
        {items.map((item, index) => (
          <li key={index} className="cancel-info__item cgt-text-medium">
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}

CancelInfo.propTypes = {
  locale: string,
  planType: string,
  gracePeriodEligible: bool,
}

export default CancelInfo
